function hasUnsafeCharacter(value: string, allowSpace = false): boolean {
  return [...value].some(character => {
    const code = character.charCodeAt(0);
    return character === '\\' || code < (allowSpace ? 32 : 33) || code === 127;
  });
}

/** Only the browser login return target is restricted; native OAuth stays separate. */
export function getLoginReturnPath(
  target: string | null | undefined,
  origin: string,
  basename = '/'
): string {
  if (!target || hasUnsafeCharacter(target) || target.startsWith('//')) {
    return '/app';
  }
  try {
    const url = new URL(target, origin);
    if (url.origin !== origin || !['http:', 'https:'].includes(url.protocol))
      return '/app';
    const base = basename.replace(/\/$/, '');
    const path =
      base && url.pathname === base
        ? '/'
        : base && url.pathname.startsWith(`${base}/`)
          ? url.pathname.slice(base.length)
          : url.pathname;
    const decodedPath = decodeURIComponent(path);
    if (
      path.startsWith('//') ||
      decodedPath.startsWith('//') ||
      hasUnsafeCharacter(decodedPath, true) ||
      /^\/(?:login|sign-in|signin)\/?$/i.test(decodedPath)
    )
      return '/app';
    return path + url.search + url.hash;
  } catch {
    return '/app';
  }
}
